export enum EssItemGroup {
  Phone = 'Phone',
  Tablet = 'Tablet',
  SmartWatch = 'Smart Watch',
}